import AddOrEditWarranty from "../common/add-or-edit-warranty";

export default function AddOrEditCompanyLogbookWarranty() {
  return <AddOrEditWarranty />;
}
